<template>
  <div>
    <!-- 头部 -->
    <top></top>
      <!-- logo -->
      <div class="logo">
        <img v-if="bannerArr.length>0" :src="$imgUrl+bannerArr[0].thumb" alt=""/>
      </div>
      <div class="exhibitor_detail_box">
        <div class="ex_d_content">
            <div class="ex_d_top_box" v-if="companyDetail.logo||companyDetail.name_cn||companyDetail.name_en||companyDetail.address||companyDetail.address_en||companyDetail.booth_no">
                <div class="ex_d_left">
                  <img class="top_img" v-if="companyDetail.logo" :src="$imgUrl+companyDetail.logo" alt=""/>
                  <div class="top_txt_box" v-if="companyDetail.name_cn||companyDetail.name_en||companyDetail.address||companyDetail.address_en">
                    <div class="top_txt1" v-if="companyDetail.name_cn">{{ companyDetail.name_cn }}</div>
                    <div class="top_txt1 top_txt_cen" v-if="companyDetail.name_en">{{ companyDetail.name_en }}</div>
                    <div class="top_txt2" v-if="companyDetail.address||companyDetail.address_en">{{ langSet=='cn'?companyDetail.address:companyDetail.address_en }}</div>
                  </div>
                </div>
                <div class="ex_top_btn" v-if="companyDetail.booth_no">
                  <img src="../../assets/adress1.jpg" alt="">
                  <span class="booth">{{langSet=='cn'?'展位号':'Booth Number'}}：{{ companyDetail.booth_no }}</span>
                </div>
            </div>
            <div class="ex_d_prod_box">
               <div class="ex_d_prod_title">
                  <div class="ex_d_prod_left">{{langSet=='cn'?'产品详情':'Product Details'}}</div>
               </div>
               <div class="prod_d_box">
                   <img v-if="productDetail.imgs" :src="$imgUrl+productDetail.imgs" alt="">
                   <div class="prod_d_content_box">
                    <div class="prod_d_top">
                      <div class="prod_d_top_left" v-if="productDetail.name_cn||productDetail.name_en||productDetail.mobile">
                           <div  v-if="productDetail.name_cn">{{ productDetail.name_cn }}</div>
                           <div  v-if="productDetail.name_en">{{ productDetail.name_en }}</div>
                      </div>
                      <div class="prod_d_top_right"  v-if="productDetail.mobile">{{langSet=='cn'?'联系电话':'Contact Number'}}：{{ productDetail.mobile }}</div>
                   </div>
                   <div class="prod_d_title"  v-if="productDetail.type_name1||productDetail.type_name2||productDetail.type_name1_en||productDetail.type_name2_en">
                     <span  class="prod_d_item" >{{langSet=='cn'?'产品类别':'Product Category'}}：</span>
                     <span class="prod_tags"  v-if="productDetail.type_name1||productDetail.type_name1_en">{{langSet=='cn'?productDetail.type_name1:productDetail.type_name1_en}}</span>
                     <span class="prod_tags"  v-if="productDetail.type_name2||productDetail.type_name2_en">{{langSet=='cn'?productDetail.type_name2:productDetail.type_name2_en }}</span>
                   </div>
                   <div class="prod_d_item" v-if="productDetail.manufacturer">{{langSet=='cn'?'制 造 商':'Manufacturer'}} ：{{ productDetail.manufacturer }}</div>
                   <div class="prod_d_item" v-if="productDetail.model">{{langSet=='cn'?'型 号':'Type Number'}} ：{{ productDetail.model }}</div>
                   <div class="prod_d_item" v-if="productDetail.country_area">{{langSet=='cn'?'国家/地区':'Country/Region'}}：{{ productDetail.country_area }}</div>
                   <div class="prod_d_item" v-if="productDetail.show_type">{{langSet=='cn'?'展示类别':'Display Category'}} ：{{ productDetail.show_type }}</div>
                   <div class="prod_d_item" v-if="productDetail.email">E-mail ：{{ productDetail.email }}</div>

                   <div class="product_use" v-if="productDetail.purpose">产品用途 / Product Usage</div>
                   <div  class="prod_d_item" v-if="productDetail.purpose">{{ productDetail.purpose }}</div>
                   <div  class="product_use" v-if="productDetail.performance">产品性能指标 / Product performance indicators</div>
                   <div  class="prod_d_item" v-if="productDetail.performance">{{ productDetail.performance }}</div>
                   </div>
               </div>

            </div>
        </div>
          
      </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import {getBanner,geCompanyDetail,getproductDetail} from "@/api/api";
export default {
  components: { top, bottom },
  name: "exhibitorDetail",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.langSet=='cn'?this.productDetail.name_cn:this.productDetail.name_en,
      meta: [
        { 
          name: 'description', 
          content: this.langSet=='cn'?this.productDetail.purpose:this.productDetail.purpose
        }
      ]
    }
  },
  data() {
    return {
      companyList:[],
      langSet:'',
      bannerArr:[],
      company_long_id:'',
      product_long_id:'',
      companyDetail:{},
      productDetail:{}
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.company_long_id=this.$route.query.company_long_id;
    this.product_long_id=this.$route.query.product_long_id;
    this.getBannerList()
    this.getCompanyDetail()
    this.getproductDetail()
   
  },
  methods: {
    // zhang 获取产品详情banner
    getBannerList(){
      let data={
        class:'产品详情',
        lang_type: this.langSet
      }
      getBanner(data).then(res=>{
        if(res.code == 1){
          this.bannerArr=res.data.lists;
        }
          
      }).catch(err=>{
        console.log(err)
      })
    },
    // zhang 获取展商详情
    getCompanyDetail(){
      let data={
        company_long_id:this.company_long_id
      }
      geCompanyDetail(data).then(res=>{
        if(res.code == 1){
          this.companyDetail=res.data;
        }
          
      }).catch(err=>{
        console.log(err)
      })
    },
    getproductDetail(){
      let data={
        product_long_id:this.product_long_id
      }
      getproductDetail(data).then(res=>{
        if(res.code == 1){
          this.productDetail=res.data;
        }
          
      }).catch(err=>{
        console.log(err)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.logo{
    width: 100%;
    height: 400px;
    img{
      width: 100%;
      height: 400px;
    }
}
.exhibitor_detail_box{
  width: 100%;
 
  .exhibitor_detail_tab_box{
     padding: 25px 0 0;
     box-sizing: border-box;
  }
  .ex_d_content{
    width: 100%;
    padding-top: 50px;
    background: #FFFFFF;
    box-shadow: 0px 2px 28px 0px rgba(0,0,0,0.08);
    padding-bottom: 50px;
    .ex_d_top_box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: #243889;
      margin: 0 auto;
      .ex_d_left{
        display: flex;
        align-items: center;
      }
      .ex_top_btn{
        display: flex;
        align-items: center;
        background: rgba(255,255,255,0.3);
        height: 48px;
        line-height: 48px;
        border-radius: 29px;
        padding: 0 21px;
        box-sizing: border-box;
        img{
          width: 13px;
          height: 18px;
          // background: #000000;
        }
        .booth{
          display: inline-block;
          margin-left: 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
        }
      }
      .top_img{
        width: 118px;
        height: 118px;
        background: #FFFFFF;
        border-radius: 20px;
        margin-right: 20px;
      }
      .top_txt_box{
        .top_txt1{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #FFFFFF;
        }
        .top_txt_cen{
          margin: 12px 0;
        }
        .top_txt2{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255,255,255,0.8);
        }
      }
    }
    .contact_box{
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: rgba(171,181,205,0.1);
      margin: 50px auto 0;
      .ex_d_prod_title{
         margin-bottom: 30px;
         .ex_d_prod_left{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 22px;
          color: #2C2C2E;
         }
      }
      .contact_list{
        .contact_item{
          display: flex;
          align-items: center;
          margin-bottom:14px;
            img{
              width:18px;
              height: 18px;
            }
            span{
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #2C2C2E;
              margin-left: 8px;
            }
        }
      }
    }
    .recruitment_box{
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: rgba(171,181,205,0.1);
      margin: 50px auto 0;
      .ex_d_prod_title{
         margin-bottom: 30px;
         .ex_d_prod_left{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 22px;
          color: #2C2C2E;
         }
      }
      .recruitment_list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .recruitment_item{
          width: -webkit-calc((100% - 20px*2)/ 2);
            width: calc((100% - 23px*2)/ 2);
            padding: 22px 25px 20px 20px;
            box-sizing: border-box;
            background: #FFFFFF;
            margin: 0 20px 20px 0;
        }
        .recruitment_top_box{
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          .title{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #2C2C2E;
          }
          .price span:nth-child(1){
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #2C2C2E;
          }
          .price span:nth-child(2){
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 18px;
              color: #FF6A0A;
              margin-left: 8px;
          }
        }
        .recruitment_content{
          width: 100%;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #757575;
          margin-bottom: 15px;
          line-height: 20px;
        }
        .recruitment_contact{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #2C2C2E;
        }
      }
    }
    .ex_d_prod_box{
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: rgba(171,181,205,0.1);
      margin: 50px auto 0;
      .prod_d_box{
        width: 100%;
        display: flex;
        flex-direction: row;
        .prod_d_title{
          line-height: 25px;
          .prod_tags{
            padding:0 8px;
            box-sizing: border-box;
            height: 21px;
            background: rgba(36,56,137,0.1);
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #243889;
            line-height: 21px;
            text-align: center;
            margin-right: 10px;
          }
        }
        .product_use{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #2C2C2E;
          line-height: 22px;
          border-bottom: 1px solid rgba(36,56,137,0.2);
          margin-top: 30px;
          padding-bottom: 5px;
          box-sizing: border-box;
          margin-bottom: 15px;
        }
        .prod_d_item{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #2C2C2E;
          line-height: 25px;
         
        }
        img{
          width: 273px;
          height: 275px;
        }
        .prod_d_content_box{
          width: 100%;
             display: flex;
             flex-direction: column;
             margin-left: 28px;
            .prod_d_top{
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              .prod_d_top_left{
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #2C2C2E;
                line-height: 25px;
              }
              .prod_d_top_right{
                padding: 0 15px;
                box-sizing: border-box;
                height: 50px;
                line-height: 50px;
                background: #243889;
                border-radius: 25px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
              }
            }
        }
        
      }
      .ex_d_prod_title{
         display: flex;
         justify-content: space-between;
         margin-bottom: 30px;
         .ex_d_prod_left{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #2C2C2E;
         }
         .more {
            font-size: 20px;
            color: #757575;
            cursor: pointer;
            text-align: right;
            line-height: 28px;
            .more-icon {
              width: 18px;
              margin-left: 14px;
            }
          }
      }
      .ex_list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .ex_item{
            width: -webkit-calc((100% - 23px*5)/ 5);
            width: calc((100% - 23px*5)/ 5);
          
            background: #FFFFFF;
            margin: 0 20px 20px 0;
            .ex_item_top{
               padding: 15px;
               box-sizing: border-box;
               .ex_title{
                width: 100%;
                line-height: 22px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #2C2C2E;
              }
              .ex_logo{
                width: 188px;
                height: 105px;
                margin: 10px 0;
              }
            }
            .ex_tag_list{
               display: flex;
               padding: 15px;
               box-sizing: border-box;
               .ex_tag_item{
                width: 64px;
                height: 21px;
                line-height: 21px;
                text-align: center;
                background: rgba(36,56,137,0.1);
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #243889;
                margin-right: 8px;
                margin-bottom: 15px;
               }
            }
            .ex_line{
              width: 100%;
              height: 1px;
              background: #EEEEEE;
            }
         
            .img{
              width: 100%;
              height: 105px;
            }
            .ex_address{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #757575;
                margin-top: 5px;
            }
            .ex_bottom_box{
                margin-top: 15px;
                padding-bottom: 15px;
                padding-left: 15px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                .ex_booth{
                    display: flex;
                    img{
                        width: 13px;
                        height: 18px; 
                    }
                    span{
                        display: inline-block;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #2C2C2E;
                        margin-left: 8px;
                    }
                }
                .ex_detail{
                    span{
                        display: inline-block;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #757575;
                    }
                    img{
                        width: 7px;
                        height: 10px;
                        margin-left: 6px;
                    }
                }
            }
        }
        .ex_item:hover{
            border: 1px solid #243889;
        }
    }
    .ex_list::after{
        content: "";
        flex: auto;
    }
      
    }
  }
}
@media only screen and (max-width: 1280px) {
  .exhibitor_detail_box .ex_d_content .ex_d_top_box,
  .exhibitor_detail_box .ex_d_content .ex_d_prod_box{
    width: 90%;
  }
}
@media only screen and (max-width: 767px) {
  .logo{
    margin-top: 0.88rem;
    height: auto;
    img{
      height: auto;
    }
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box .ex_d_left{
    flex: 1;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box .ex_top_btn{
    background: transparent;
    padding: 0;
    position: absolute;
    bottom: -5px;
    right: 5px;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box .top_txt_box{
    flex: 1;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box .top_txt_box .top_txt1{
    font-size: 16px;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box .top_txt_box .top_txt2{
    font-size: 13px;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box .ex_top_btn .booth{
    font-size: 12px;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_prod_box .ex_d_prod_title{
    margin-bottom: 20px;
  }
  .exhibitor_detail_box .ex_d_content{
    padding-top: 0;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box,
  .exhibitor_detail_box .ex_d_content .ex_d_prod_box{
    width: 90%;
    padding: 15px;
    margin: 30px auto;
    position: relative;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_top_box .top_img{
    width: 70px;
    height: 70px;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_prod_box .prod_d_box{
    flex-wrap: wrap;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_prod_box .prod_d_box img{
    width: 100%;
    height: auto;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_prod_box .prod_d_box .prod_d_content_box{
    margin-left: 0;
    margin-top: 30px;
    position: relative;
    padding-bottom: 60px;
  }
  .exhibitor_detail_box .ex_d_content .ex_d_prod_box .prod_d_box .prod_d_content_box .prod_d_top .prod_d_top_right{
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
<style lang="scss">
   .exhibitor_detail_box .ex_d_tab_list{
      width: 1280px;
      margin: 0 auto;
   }
   .exhibitor_detail_tab_box .el-tabs__nav-wrap::after{
    background: transparent;
   }
   .exhibitor_detail_tab_box .el-tabs__item{
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 22px;
        color: #2C2C2E;
        height: 48px;
        line-height: 48px;
        padding: 0 0 0 210px;
   }
   .exhibitor_detail_tab_box .el-tabs__item:nth-last-child(1){
      padding-right: 0 !important;
   }
   .exhibitor_detail_box .el-tabs__item.is-active{
    color: #243889;
   }
   .exhibitor_detail_tab_box .el-tabs__active-bar{
    width: 88px;
    height: 5px;
    background: #243889;
   }
   .exhibitor_detail_tab_box .el-tabs__header{
    width: 100%;
   }
   .exhibitor_detail_tab_box .el-tabs__nav-scroll{
    width: 100%;
   }
   .exhibitor_detail_tab_box .el-tabs__nav{
    width: 100%;
   }

   .prod_tab_box .el-tabs__item{
    padding: 0 0 0 115px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #2C2C2E;
   }
   .prod_tab_box .el-tabs__active-bar{
    height: 3px;
    background: #243889;
   }
</style>